import ExhibitionStatisticHelper from "./exhibition-statistic-helper";
import ExhibitionHelper from "./exhibition-helper";

const ExhibitionHelpers = {
    Statistic : ExhibitionStatisticHelper,
    EE        : ExhibitionHelper
};

export default ExhibitionHelpers;